module.exports = __webpack_public_path__ + "img/d_9.7541600d.png";